/**
 * This module improves tab navigation and focus management for designated sections of a webpage,
 * particularly when scrolling to specific sections.
 * It ensures that focusable elements are accessible and appropriately navigated when the "Tab" key is pressed,
 * considering both forward and backward navigation.
 */
const initTabHandling = (nextSelector = '', previousSelector = '') => {

	const hasHiddenAncestor = (elementsToFilter) => Array.from(elementsToFilter).filter((element) => {

		const hiddenAncestor = element.closest('.hidden');
		return !hiddenAncestor;

	});

	const findPrevTabableElement = (SourceElement) => {

		if (SourceElement) {

			const childElements = SourceElement.previousElementSibling.querySelectorAll(
				'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
			);
			const filteredElements = hasHiddenAncestor(childElements);
			if (filteredElements.length) {

				return filteredElements[childElements.length - 1];

			}
			return findPrevTabableElement(SourceElement.previousElementSibling);

		}

		return null;

	};

	const removeEventListeners = () => {

		document.removeEventListener('keydown', handleTab);
		document.removeEventListener('click', removeEventListeners);

	};

	const handleTab = (event) => {

		if (event.key === 'Tab' || (event.shiftKey && event.key === 'Tab')) {

			const nextSection = document.querySelector(nextSelector);

			if (!nextSection) return;

			if (event.key === 'Tab' && !event.shiftKey) {

				const focusableElements = nextSection.querySelectorAll(
					'a:not([disabled]), button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
				);
				if (focusableElements.length > 0) {

					const currentFocusedElement = document.activeElement;
					if (currentFocusedElement) {

						const currentIndex = Array.from(focusableElements).indexOf(currentFocusedElement);
						const nextIndex = (currentIndex + 1) % focusableElements.length;
						const nextElement = focusableElements[nextIndex];

						if (nextElement) {

							nextElement.setAttribute('tabindex', '0');
							event.preventDefault();
							nextElement.focus();

						}

					}

				}

			} else if (event.key === 'Tab' && event.shiftKey) {

				const elementToSearch = previousSelector || nextSelector;
				const targetSection = document.querySelector(elementToSearch);
				const previousTabbableElement = findPrevTabableElement(targetSection);

				if (previousTabbableElement) {

					previousTabbableElement.setAttribute('tabindex', '0');
					event.preventDefault();
					previousTabbableElement.focus();

				}

			}

			removeEventListeners();

		}

	};

	removeEventListeners();
	document.addEventListener('keydown', handleTab);
	setTimeout(() => {

		document.addEventListener('click', removeEventListeners);

	}, 1000);

};

export default initTabHandling;
